import React from 'react';
import '../../../css/dashboardCard.css';

const Card = ({ title, value, color }) => {
    return (
      <div className="card" >
        <h3 style={{ color }}>{title}</h3>
        <p>{value}</p>
      </div>
    );
  };


function HeaderCard() {

    const cards = [
        { title: "Carte Adultes", value: 1000, color: "#FFFFFF" },
        { title: "Carte Mineurs", value: 500, color: "#00FF00" },
      ];
    
  return (
    <div className="card-container">
      {cards.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          value={card.value}
          color={card.color}
        />
      ))}
    </div>
  )
}

export default HeaderCard